import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import { useRouter } from 'next/router';

interface ITabs {
  [key: string]: JSX.Element;
}
interface Props {
  currentTab?: JSX.Element;
  currentTabKey?: string;
}

function useTabs(
  initialTab: string,
  allTabs: ITabs
): [Dispatch<SetStateAction<string>>, Props] {
  const { query } = useRouter();
  const [currentTabKey, setCurrentTabKey] = useState(initialTab);

  useEffect(() => {
    if (query.t) {
      if (allTabs[query.t!.toString()]) {
        setCurrentTabKey(query.t!.toString());
      } else {
        setCurrentTabKey('myListings');
      }
    }
  }, [query, allTabs]);
  return [
    setCurrentTabKey,
    {
      currentTab: allTabs[currentTabKey],
      currentTabKey,
    },
  ];
}

export default useTabs;
